t = require('app/scripts/views/internal/teacup-with-helpers')('popover_auto_mentioner')

module.exports = ->
  t.mustacheBlock 'button', ->
    t.input '.js-filter-mentionables.js-autofocus', { type: 'text', placeholder: t.l('search-members-ellipsis') }

  t.p '.quiet.js-empty-list.hide', { style: 'padding: 8px 8px 0;' }, ->
    t.format 'no-matching-members'

  t.ul '.pop-over-member-list.js-available-members'
